import climatizacion from '../../assets/img/climatizacion.png'
import gps from '../../assets/img/gps.png'
import banio from '../../assets/img/banio.png'
import multimedia from '../../assets/img/multimedia.png'

export const listOfferTicketItem = [
    {
        id: 1,
        type: 'Buscama',
        inclination: '160º / 140º',
        seatingNumber: '6',
        price: '90.00',
        initTime: '09:00 am',
        arrivalTime: '06:20 pm',
        fromCity: 'Lima - Plaza Norte',
        toCity: 'Chiclayo',
        time: '15 Hrs. 30 Min.',
        listOptions: [
            {
                id: 1,
                icon: climatizacion,
            },
            {
                id: 2,
                icon: gps,
            },
            {
                id: 3,
                icon: banio,
            },
            {
                id: 4,
                icon: multimedia,
            },
          ],
    },
    {
        id: 2,
        type: 'Buscama',
        inclination: '160º / 140º',
        seatingNumber: '6',
        price: '90.00',
        initTime: '09:00 am',
        arrivalTime: '06:20 pm',
        fromCity: 'Lima - Plaza Norte',
        toCity: 'Chiclayo',
        time: '15 Hrs. 30 Min.',
        listOptions: [
            {
                id: 1,
                icon: climatizacion,
            },
            {
                id: 2,
                icon: gps,
            },
            {
                id: 3,
                icon: banio,
            },
            {
                id: 4,
                icon: multimedia,
            },
          ],
    },
    {
        id: 3,
        type: 'Buscama',
        inclination: '160º / 140º',
        seatingNumber: '6',
        price: '90.00',
        initTime: '09:00 am',
        arrivalTime: '06:20 pm',
        fromCity: 'Lima - Plaza Norte',
        toCity: 'Chiclayo',
        time: '15 Hrs. 30 Min.',
        listOptions: [
            {
                id: 1,
                icon: climatizacion,
            },
            {
                id: 2,
                icon: gps,
            },
            {
                id: 3,
                icon: banio,
            },
            {
                id: 4,
                icon: multimedia,
            },
          ],
    }
]